
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetType = typeof DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetType[keyof typeof DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
